<template>
  <NormalHeaderLayout header="Data source">
    <div class="section">
      <h2>Data collection</h2>
      <p>
        DASH collects data from more than 60 honeynet sensors spread across more
        than 15 economies in the Asia Pacific. These sensors have been deployed
        as part of the
        <a
          href="https://blog.apnic.net/2019/09/17/the-apnic-community-honeynet-project/"
          target="_blank"
        >APNIC's honeynet project</a>
        .
      </p>
      <p>
        We are still looking for partners to participate in the Community
        Honeynet Project. If you would like to participate in the project and
        contribute to DASH, please, express your interest by sending an email to
        <a
          href="mailto: project@honeynet.asia"
          target="_blank"
        >project@honeynet.asia</a>.
      </p>
    </div>
    <div class="section">
      <h2>How honeypots work</h2>
      <p>
        Learn about honeypots and the
        <a
          href="https://academy.apnic.net/en/webinar-courses/learning-from-honeypots/"
          target="_blank"
        >Community Honeynet Project</a>.
      </p>
    </div>
    <div class="section">
      <h2>Acknowledgement</h2>
      <p>
        APNIC would like to acknowledge the following partners for contributing
        data to this project:
      </p>
      <ul>
        <li>Bhutan Telecom (BT)</li>
        <li>Bhutan Computer Incident Response Team (BT)</li>
        <li>Fibre@Home Limited (BD)</li>
        <li>Malaysia Research and Education Network (MYREN) (MY)</li>
        <li>GEMNET (MN)</li>
        <li>Universiti Pendidikan Sultan Idris (MY)</li>
        <li>Universitas Islam Indonesia (ID)</li>
        <li>Ministry of Health (WS)</li>
        <li>Ezecom (KH)</li>
        <li>Universitas Tanjungpura (ID)</li>
        <li>Tonga Communications Corporation (TO)</li>
      </ul>
    </div>
  </NormalHeaderLayout>
</template>

<script>
import NormalHeaderLayout from '../components/layout/NormalHeaderLayout';

export default {
  components: {
    NormalHeaderLayout
  }
};
</script>
